import { render } from "./InConsoleSidebar.vue.ts?vue&type=template&id=a2cd7617&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InConsoleSidebar.vue?vue&type=template&id=a2cd7617&ts=true"
import script from "./InConsoleSidebar.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InConsoleSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./InConsoleSidebar.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InConsoleSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./InConsoleSidebar.vue.scss?vue&type=style&index=0&id=a2cd7617&lang=scss!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InConsoleSidebar.vue?vue&type=style&index=0&id=a2cd7617&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/merchant3/components/in-console/ui/InConsoleSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a2cd7617"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a2cd7617', __exports__)) {
    api.reload('a2cd7617', __exports__)
  }
  
  module.hot.accept("./InConsoleSidebar.vue.ts?vue&type=template&id=a2cd7617&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InConsoleSidebar.vue?vue&type=template&id=a2cd7617&ts=true", () => {
    api.rerender('a2cd7617', render)
  })

}


export default __exports__